import { Check } from "lucide-react";
import { formatNZD } from "@/lib/api";

export default function OptionGrid({ group, value, onChange, testPrefix = "option" }) {
  return (
    <div data-testid={`option-group-${group.id}`}>
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">
        {group.label}
      </p>
      {group.help && (
        <p className="mt-1 text-xs text-zinc-500">{group.help}</p>
      )}
      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        {group.choices.map((c) => {
          const active = value === c.id;
          return (
            <button
              key={c.id}
              type="button"
              data-testid={`${testPrefix}-${group.id}-${c.id}`}
              aria-pressed={active}
              onClick={() => onChange(group.id, c.id)}
              className={`relative rounded-xl border p-4 text-left transition-colors duration-200 ${
                active
                  ? "border-volt bg-volt/5"
                  : "border-black/10 bg-white hover:border-black/30 hover:bg-surface"
              }`}
            >
              <div className="flex items-center justify-between gap-2">
                <span className="font-display text-sm font-bold text-ink">
                  {c.name}
                </span>
                {active && (
                  <Check className="h-4 w-4 shrink-0 text-volt" strokeWidth={3} />
                )}
              </div>
              <p className="mt-1 text-xs leading-relaxed text-zinc-500">
                {c.note}
              </p>
              <p
                className={`mt-2 font-mono text-xs ${
                  active ? "text-volt" : "text-zinc-500"
                }`}
              >
                {c.price_delta === 0 ? "Included" : `+ ${formatNZD(c.price_delta)}`}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
